import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTour } from '@reactour/tour';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Task } from 'utils/types';

import c from '../utils/constants';

export default function useUpdateTaskStatus() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen } = useTour();
  const args = state;

  return useMutation({
    mutationFn: async (payload: { id: string; status: string }) => {
      if (isOpen) {
        return;
      }

      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/tasks/${payload.id}/${payload.status}`,
            payload,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/tasks/${payload.id}/${payload.status}`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: ({ data }: Task, payload) => {
      queryClient.invalidateQueries([c.TASKS, {}]);
      queryClient.invalidateQueries({ queryKey: [c.LOGS, data?.dealId] });

      toastSuccess(
        `Successfully updated task to ${payload.status.toLowerCase()}.`,
      );
    },
  });
}
